<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
        <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                 @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
            <el-row :gutter="15">

                                <el-form-item label="最近一次修改管理员:">
                    <el-select v-model="table.where.admin_id" filterable placeholder="请选择">
                        <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname+item.mobile" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                                            <el-form-item label="店铺名称:">
                    <el-input v-model="table.where.name" placeholder="请输入店铺名称"  clearable/>
                </el-form-item>
                                            <el-form-item label="公司名称:">
                    <el-input v-model="table.where.company_name" placeholder="请输入公司名称"  clearable/>
                </el-form-item>
                                                                                    <el-form-item label="行业:">
                        <el-select v-model="table.where.industry_id" filterable placeholder="请选择">

                            <el-option v-for="item in fresh_industry_list" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                                                                                <el-form-item label="起订金额:">
                    <el-input-number v-model="table.where.price" placeholder="请输入起订金额" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                </el-form-item>
                                                                                                            <el-form-item label="客服电话:">
                    <el-input v-model="table.where.server_tel" placeholder="请输入客服电话"  clearable/>
                </el-form-item>
                                            <el-form-item label="客服微信账号:">
                    <el-input v-model="table.where.server_wx" placeholder="请输入客服微信账号"  clearable/>
                </el-form-item>
                                                            <el-form-item label="状态:">
                    <el-select v-model="table.where.status" filterable placeholder="请选择">
                                                <el-option label="使用" value="1"></el-option>
                                                <el-option label=" 未审核 " value="2"></el-option>
                                                <el-option label="关店 " value="3"></el-option>
                                                <el-option label="禁用" value="9"></el-option>
                                            </el-select>
                </el-form-item>
                                            <el-form-item label="原因:">
                    <el-input v-model="table.where.status_into" placeholder="请输入原因"  clearable/>
                </el-form-item>
                                            <el-form-item label="优选商家:">
                    <el-input-number v-model="table.where.optimization" placeholder="请输入优选商家" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                </el-form-item>
                                            <el-form-item label="销量:">
                    <el-input-number v-model="table.where.sales_volume" placeholder="请输入销量" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                </el-form-item>
                                            <el-form-item label="基础运费:">
                    <el-input-number v-model="table.where.freight" controls-position="right" :min="0" :controls="false"
                                     :precision="1" class="ele-fluid ele-text-left" placeholder="请输入基础运费" clearable />
                </el-form-item>

                                            <el-form-item label="地区:">
                    <el-cascader v-model="table.where.region" :options="cityData.cityDataLabel" clearable
                                 popper-class="ele-pop-wrap-higher"  :props="{ checkStrictly: true }" />
                </el-form-item>
                                                            <el-form-item label="主营商品:">
                    <el-input v-model="table.where.main_goods" placeholder="请输入主营商品"  clearable/>
                </el-form-item>
                                            <el-form-item label="法人:">
                    <el-input v-model="table.where.legal_person" placeholder="请输入法人"  clearable/>
                </el-form-item>
                                            <el-form-item label="身份证:">
                    <el-input v-model="table.where.identity_card" placeholder="请输入身份证"  clearable/>
                </el-form-item>
                                            <el-form-item label="排序:">
                    <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                </el-form-item>
                                            <el-form-item label="创建时间:" >
                    <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                                    end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </el-form-item>
                


            <el-form-item>
                <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                           class="ele-btn-icon">查询
                </el-button>
                <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                           v-if="permission.includes('sys:freshshopmanagement:export')">导出数据
                </el-button>
            </el-form-item>
        </el-row>
    </el-form>
      <!-- 操作按钮 -->

      <div class="ele-table-tool ele-table-tool-default">
          <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                     class="ele-btn-icon" size="small" >刷新
          </el-button>
        <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:freshshopmanagement:add')">添加
        </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:freshshopmanagement:dall')">批量删除
        </el-button>
          <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                     @click="search_show=!search_show">搜索</el-button>
      </div>

      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                        <el-table-column prop="admin_id" label="最近一次修改管理员" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-tag v-for="(item,index) in row.admin_id_info" :key="index">{{item.realname+item.mobile}}</el-tag>
                </template>
            </el-table-column>
                                <el-table-column prop="name" label="店铺名称" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="company_name" label="公司名称" sortable="custom" show-overflow-tooltip min-width="120"/>

                                                
                    <el-table-column prop="industry_id" label="行业" show-overflow-tooltip min-width="250" >
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.industry_id_info" :key="index">{{item.name}}</el-tag>
                        </template>
                    </el-table-column>

                            
                                <el-table-column prop="price" label="起订金额" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="logo_image" label="店铺LOGO" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-image
                            style="width: 50px; height: 50px"
                            :src="row.logo_image"
                            :preview-src-list="[row.logo_image]">
                    </el-image>
                </template>
            </el-table-column>
                                <el-table-column prop="album_image" label="店铺相册" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-image
                            style="width: 50px; height: 50px"
                            :src="row.album_image"
                            :preview-src-list="[row.album_image]">
                    </el-image>
                </template>
            </el-table-column>
                                <el-table-column prop="business_image" label="营业执照" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-image
                            style="width: 50px; height: 50px"
                            :src="row.business_image"
                            :preview-src-list="[row.business_image]">
                    </el-image>
                </template>
            </el-table-column>
                                <el-table-column prop="server_image" label="客服二维码照片" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-image
                            style="width: 50px; height: 50px"
                            :src="row.server_image"
                            :preview-src-list="[row.server_image]">
                    </el-image>
                </template>
            </el-table-column>
                                <el-table-column prop="server_tel" label="客服电话" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="server_wx" label="客服微信账号" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="server_timerange" label="工作时间" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-tag v-for="(item,index) in row.server_timerange" :key="index">{{item}}</el-tag>
                </template>
            </el-table-column>
                                <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                                            <el-tag v-if="row.status == 1" :key="index">使用</el-tag>
                                            <el-tag v-if="row.status == 2" :key="index"> 未审核 </el-tag>
                                            <el-tag v-if="row.status == 3" :key="index">关店 </el-tag>
                                            <el-tag v-if="row.status == 9" :key="index">禁用</el-tag>
                                    </template>
            </el-table-column>

                                <el-table-column prop="status_into" label="原因" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="optimization" label="优选商家" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="sales_volume" label="销量" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="freight" label="基础运费" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="region" label="地区" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-tag v-for="(item,index) in row.region" :key="index">{{item}}</el-tag>
                </template>
            </el-table-column>
                                            <el-table-column prop="main_goods" label="主营商品" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="legal_person" label="法人" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="identity_card" label="身份证" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip min-width="120"/>

                        
          <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:freshshopmanagement:edit')">修改</el-link>
              <el-popconfirm title="确定要删除此店铺管理吗？" @confirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:freshshopmanagement:delete')">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改店铺管理':'添加店铺管理'" :visible.sync="showEdit"  width="800px" :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
        
          <el-form-item label="最近一次修改管理员:" prop="admin_id">
              <el-select v-model="editForm.admin_id" filterable placeholder="请选择">
                  <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname+item.mobile" :value="item.id">
                  </el-option>
              </el-select>

          </el-form-item>
                          <el-form-item label="店铺名称:" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入店铺名称" clearable />
          </el-form-item>
                          <el-form-item label="公司名称:" prop="company_name">
              <el-input v-model="editForm.company_name" placeholder="请输入公司名称" clearable />
          </el-form-item>
                
                                          <el-form-item label="行业:" prop="industry_id">
                      <el-select v-model="editForm.industry_id" filterable placeholder="请选择">
                          <el-option v-for="item in fresh_industry_list" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
                                                  <el-form-item label="起订金额:" prop="price">
              <el-input-number v-model="editForm.price" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入起订金额" clearable />
          </el-form-item>
                
          <el-form-item label="店铺LOGO:" prop="logo_image">
              <ele-uploadimage :limit="1" v-model="editForm.logo_image"></ele-uploadimage>

          </el-form-item>
                
          <el-form-item label="店铺相册:" prop="album_image">
              <ele-uploadimage :limit="1" v-model="editForm.album_image"></ele-uploadimage>

          </el-form-item>
                
          <el-form-item label="营业执照:" prop="business_image">
              <ele-uploadimage :limit="1" v-model="editForm.business_image"></ele-uploadimage>

          </el-form-item>
                
          <el-form-item label="客服二维码照片:" prop="server_image">
              <ele-uploadimage :limit="1" v-model="editForm.server_image"></ele-uploadimage>

          </el-form-item>
                          <el-form-item label="客服电话:" prop="server_tel">
              <el-input v-model="editForm.server_tel" placeholder="请输入客服电话" clearable />
          </el-form-item>
                          <el-form-item label="客服微信账号:" prop="server_wx">
              <el-input v-model="editForm.server_wx" placeholder="请输入客服微信账号" clearable />
          </el-form-item>
                
          <el-form-item label="工作时间:" prop="server_timerange">
              <el-time-picker is-range v-model="editForm.server_timerange" range-separator="至" start-placeholder="开始时间"
                              end-placeholder="结束时间" placeholder="选择时间范围" value-format="hh:mm:ss">
              </el-time-picker>
          </el-form-item>
                          <el-form-item label="状态:" prop="status">
              <el-select v-model="editForm.status" filterable placeholder="请选择状态">
                                        <el-option label="使用" value="1"></el-option>
                                        <el-option label=" 未审核 " value="2"></el-option>
                                        <el-option label="关店 " value="3"></el-option>
                                        <el-option label="禁用" value="9"></el-option>
                                </el-select>
          </el-form-item>

                          <el-form-item label="原因:" prop="status_into">
              <el-input v-model="editForm.status_into" placeholder="请输入原因" clearable />
          </el-form-item>
                          <el-form-item label="优选商家:" prop="optimization">
              <el-input-number v-model="editForm.optimization" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入优选商家" clearable />
          </el-form-item>
                          <el-form-item label="销量:" prop="sales_volume">
              <el-input-number v-model="editForm.sales_volume" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入销量" clearable />
          </el-form-item>
                
          <el-form-item label="基础运费:" prop="freight">
              <el-input-number v-model="editForm.freight" controls-position="right" :min="0" :controls="false" :precision="4" class="ele-fluid ele-text-left" placeholder="请输入基础运费" clearable />
          </el-form-item>
                
          <el-form-item label="地区:" prop="region">
              <el-cascader v-model="editForm.region" :options="cityData.cityDataLabel" clearable
                           popper-class="ele-pop-wrap-higher"  :props="{ checkStrictly: true }" />
          </el-form-item>
                
          <el-form-item label="地图:" prop="map">
              <ele-upload-map v-model="editForm.map"></ele-upload-map>
          </el-form-item>

                          <el-form-item label="主营商品:" prop="main_goods">
              <el-input v-model="editForm.main_goods" placeholder="请输入主营商品" clearable />
          </el-form-item>
                          <el-form-item label="法人:" prop="legal_person">
              <el-input v-model="editForm.legal_person" placeholder="请输入法人" clearable />
          </el-form-item>
                          <el-form-item label="身份证:" prop="identity_card">
              <el-input v-model="editForm.identity_card" placeholder="请输入身份证" clearable />
          </el-form-item>
                          <el-form-item label="排序:" prop="sort">
              <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
          </el-form-item>
                       
      </el-form>
      <div slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import { mapGetters } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'
                import cityData from '@/utils/cityData'
                import EleUploadMap from '@/components/EleUploadMap'
    
    export default {
        name: "SysfreshShopManagement",
        components: {
                        EleUploadimage,
                                                            EleUploadMap,
                    },
        data() {
            return {
                                cityData: cityData,
                                table: {
                    url: '/fresh/freshShopManagement/index',
                    where: {"logo_image":[],"album_image":[],"business_image":[],"server_image":[],"server_timerange":[],"region":[]}                },  // 表格配置
                choose: [],  // 表格选中数据
                showEdit: false,  // 是否显示表单弹窗
                editForm: {"logo_image":[],"album_image":[],"business_image":[],"server_image":[],"server_timerange":[],"region":[]},  // 表单数据
                editFormTemp:{"logo_image":[],"album_image":[],"business_image":[],"server_image":[],"server_timerange":[],"region":[]},
                admin_list:[],
                user_list:[],
                search_show:false,
                                    fresh_industry_list:[],
                                editRules: {  // 表单验证规则
                                                            
                            admin_id: [
                                {required: true, message: '请选择最近一次修改管理员', trigger: 'blur'}
                                ],
                        
                                            
                            name: [
                                {required: true, message: '请输入店铺名称', trigger: 'blur'}],
                        
                                            
                            company_name: [
                                {required: true, message: '请输入公司名称', trigger: 'blur'}],
                        
                                            
                            industry_id: [
                                {required: true, message: '请选择行业', trigger: 'blur'}
                                ],
                        
                                            
                            price: [
                                {required: true, message: '请输入起订金额', trigger: 'blur'}],
                        
                                            
                            logo_image: [
                                {required: true, message: '请上传店铺LOGO', trigger: 'blur'}
                            ],
                        
                                            
                            album_image: [
                                {required: true, message: '请上传店铺相册', trigger: 'blur'}
                            ],
                        
                                            
                            business_image: [
                                {required: true, message: '请上传营业执照', trigger: 'blur'}
                            ],
                        
                                            
                            server_image: [
                                {required: true, message: '请上传客服二维码照片', trigger: 'blur'}
                            ],
                        
                                            
                            server_tel: [
                                {required: true, message: '请输入客服电话', trigger: 'blur'}],
                        
                                            
                            server_wx: [
                                {required: true, message: '请输入客服微信账号', trigger: 'blur'}],
                        
                                            
                            server_timerange: [
                                {required: true, message: '请选择工作时间', trigger: 'blur'}
                                ],
                        
                                            
                            status: [
                                {required: true, message: '请选择状态', trigger: 'blur'}
                                ],
                        
                                            
                            status_into: [
                                {required: true, message: '请输入原因', trigger: 'blur'}],
                        
                                            
                            optimization: [
                                {required: true, message: '请输入优选商家', trigger: 'blur'}],
                        
                                            
                            sales_volume: [
                                {required: true, message: '请输入销量', trigger: 'blur'}],
                        
                                            
                            freight: [
                                {required: true, message: '请输入基础运费', trigger: 'blur'}],
                        
                                            
                            region: [
                                {required: true, message: '请选择地区', trigger: 'blur'}
                                ],
                        
                                            
                            map: [
                                {required: true, message: '请选择地图', trigger: 'blur'}
                                ],
                        
                                            
                            main_goods: [
                                {required: true, message: '请输入主营商品', trigger: 'blur'}],
                        
                                            
                            legal_person: [
                                {required: true, message: '请输入法人', trigger: 'blur'}],
                        
                                            
                            identity_card: [
                                {required: true, message: '请输入身份证', trigger: 'blur'}],
                        
                                            
                            sort: [
                                {required: true, message: '请输入排序', trigger: 'blur'}],
                        
                                            
                            create_time: [
                                {required: true, message: '请选择创建时间', trigger: 'blur'}
                                ],
                        
                                    
            },
        }
        },
        computed: {
            ...mapGetters(["permission"]),
                    },
        mounted() {

                                    this.adminAllList();
                                    this.freshIndustryAllList();                    },
        methods: {
            /**
             * 关闭
             */
            closeDialog(){
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/fresh/freshShopManagement/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({lock: true});
                        this.$http.post('/fresh/freshShopManagement/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) {  // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的店铺管理吗?', '提示', {type: 'warning'}).then(() => {
                        const loading = this.$loading({lock: true});
                        this.$http.post('/fresh/freshShopManagement/delete', {id: ids}).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else {  // 单个删除
                    const loading = this.$loading({lock: true});
                    this.$http.post('/fresh/freshShopManagement/delete', {id:row.id}).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({type: 'success', message: res.data.msg});
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

                                    /* 获取全部管理员 */
            adminAllList(){
                this.$http.post('/admin/admin/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.admin_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
                        /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
                    //查询其他信息
           freshIndustryAllList(){
                this.$http.post('/fresh/freshIndustry/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.fresh_industry_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
        
        }
    }
</script>

<style scoped>
    .ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
        width: 100%;
    }
</style>